import { Component } from "@angular/core";
import { CandidateEditComponent } from "../candidate-edit/candidate-edit.component";
import { NewUiCandidateFlexibleEditComponent } from "./new-ui-candidate-flexible-edit.component";

@Component({
  selector: "app-candidate-flexible-edit",
  templateUrl: "./candidate-flexible-edit.component.html",
  styleUrl: "./candidate-flexible-edit.component.scss",
  imports: [CandidateEditComponent],
  host: { class: "h-full" },
})
export class CandidateFlexibleEditComponent extends NewUiCandidateFlexibleEditComponent {}
